import type WebApiClient from "../../api/WebApiClient.js";
import { createReducer } from "../redux-utils.js";
import { getProjectLabel } from "./config.js";
import { createErrorHandler } from "@/app-utils/errors.ts";
import { type Capability } from "@/graphql.ts";
import {
  LOAD_PROJECT_CAPABILITIES_LIST_FAILURE,
  LOAD_PROJECT_CAPABILITIES_LIST_REQUEST,
  LOAD_PROJECT_CAPABILITIES_LIST_SUCCESS,
} from "@/redux/action-types.ts";

/**
 * State definition
 */
export interface IProjectCapabilitiesListState {
  projectCapabilities: Capability[];
  isLoading: boolean;
}

export const initialState: IProjectCapabilitiesListState = {
  projectCapabilities: [],
  isLoading: false,
};

/**
 * Reducers
 */
export default createReducer(initialState, {
  [LOAD_PROJECT_CAPABILITIES_LIST_REQUEST]: (state: IProjectCapabilitiesListState) => {
    return { ...state, isLoading: true };
  },
  [LOAD_PROJECT_CAPABILITIES_LIST_SUCCESS]: (state: IProjectCapabilitiesListState, payload: Capability[]) => {
    return { ...state, projectCapabilities: payload, isLoading: false };
  },
  [LOAD_PROJECT_CAPABILITIES_LIST_FAILURE]: (state: IProjectCapabilitiesListState) => {
    return { ...state, isLoading: false };
  },
});

/**
 * Action creators
 */
export function loadProjectCapabilitiesList() {
  return (dispatch, _getState, webApiClient: WebApiClient) => {
    dispatch({ type: LOAD_PROJECT_CAPABILITIES_LIST_REQUEST });
    return webApiClient
      .fetchProjectCapabilitiesList()
      .then((response: Capability[]) => {
        dispatch({
          type: LOAD_PROJECT_CAPABILITIES_LIST_SUCCESS,
          payload: response,
        });
      })
      .catch(
        createErrorHandler(dispatch, {
          actionType: LOAD_PROJECT_CAPABILITIES_LIST_FAILURE,
          alertTitle: `Fetching of ${getProjectLabel(false, false)} List Failed`,
        }),
      );
  };
}
